export default __webpack_public_path__ + "static/media/Ash Orphan.c9d09d09.png";